<template>
    <el-card class="mt-3 mb-6 br-12">
        <el-row :gutter="20">
            <el-col :span="18">
                <h2 class="my-2">Sections</h2>
                <p>
                    Specify all sections that can exist in different format of
                    stores in your company
                </p>
            </el-col>
            <el-col :span="6" class="text-right">
                <div class="pt-8">
                    <!-- <el-input v-model="search_section" prefix-icon="el-icon-search" class="mr-2" size="small"
                        placeholder="Search section"></el-input> -->
                    <el-button :disabled="!hasAdminAccess || regionAccess || sub_regionAccess" type="warning" plain icon="el-icon-circle-plus-outline" size="small" class="primary-settings-button"
                        @click="openSection">Add New</el-button>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="20" class="mt-2">
            <el-col :span="12">
                <el-table :data="filtered_company_level_sections.filter((el, index) => (((index % 2) == 1 || index == 0) && (el.name != 'Location')))" style="width: 100%" max-height="400">
                    <el-table-column prop="name"></el-table-column>
                    <el-table-column>
                        <template slot-scope="scope">
                            <div class="text-right">
                                <span class="mr-4">
                                    <img :class="[(hasAdminAccess && !regionAccess && !sub_regionAccess) ? 'cursor-pointer' : 'cursor-not-allowed']" src="../../../../../assets/icons/edit-icon.svg" width="12"
                                        @click="(hasAdminAccess && !regionAccess && !sub_regionAccess) ? openSection(scope.row) : ''" />
                                </span>
                                <span>
                                    <img :class="[(hasAdminAccess && !regionAccess && !sub_regionAccess) ? 'cursor-pointer' : 'cursor-not-allowed']" src="../../../../../assets/icons/trash-icon.svg" width="12"
                                        @click="(hasAdminAccess && !regionAccess && !sub_regionAccess) ? deleteSection(scope.row.id) : ''" />
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col :span="12">
                <el-table :data="filtered_company_level_sections.filter((el, index) => (((index % 2) == 0 && index != 0) && (el.name != 'Location')))" style="width: 100%" max-height="400">
                    <el-table-column prop="name"></el-table-column>
                    <el-table-column>
                        <template slot-scope="scope">
                            <div class="text-right">
                                <span class="mr-4">
                                    <img :class="[(hasAdminAccess && !regionAccess && !sub_regionAccess) ? 'cursor-pointer' : 'cursor-not-allowed']" src="../../../../../assets/icons/edit-icon.svg" width="12"
                                        @click="(hasAdminAccess && !regionAccess && !sub_regionAccess) ? openSection(scope.row) : ''" />
                                </span>
                                <span>
                                    <img :class="[(hasAdminAccess && !regionAccess && !sub_regionAccess) ? 'cursor-pointer' : 'cursor-not-allowed']" src="../../../../../assets/icons/trash-icon.svg" width="12"
                                        @click="(hasAdminAccess && !regionAccess && !sub_regionAccess) ? deleteSection(scope.row.id) : ''" />
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>

        <add-or-edit-section></add-or-edit-section>
    </el-card>
</template>

<script>
import settingsMixin from '../../../../../../mixins/settingsMixin';
import AddOrEditSection from "./AddOrEditSection.vue";
export default {
    name: "AllCompanySections",
    components: {
        AddOrEditSection,
    },
    mixins: [settingsMixin],
}
</script>
